import React from 'react';
import Flagship from '../../core/flagship';
import {Image, Label} from 'semantic-ui-react';
import {empty} from "../../utils/helpers";

export default class UserData extends React.Component {


    render() {

        return (
            <div className="cf">
                <Image
                    className="user-photo-left"
                    floated="left"
                    className="circular"
                    size="small"
                    src={Flagship.config.uploads + (!empty(this.props.userData.photo) ? this.props.userData.photo : 'someone.png')}
                />
                <div className="user-data-right">
                    <div className="single-record-single-field">
                        <Label>Email Address</Label>
                        <div className="field-value">
                            <a href={"mailto:" + this.props.userData.email}>{this.props.userData.email}</a>
                        </div>
                    </div>

                    <div className="single-record-single-field">
                        <Label>Phone</Label>
                        <div className="field-value">
                            {!empty(this.props.userData.phone) ?
                                <a href={"tel:+1" + this.props.userData.phone}>{this.props.userData.phone}</a>
                                :
                                <em>Unlisted</em>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/components/user/UserData.js